/**
 * `sections/main-stores.liquid` — `<store-locator>`: mounts the Stockist store
 * locator widget.
 *
 * Stockist's embed script (widget.min.js) has no public re-init API and shows
 * "Currently only a single map can be displayed per page" if it runs a second
 * time on the same page. The section used to inject that <script> inline, so
 * Shopify's theme editor re-ran it on every section re-render and tripped the
 * guard. Loading the embed once per page from here (guarded) keeps the editor
 * quiet; the widget still auto-mounts on the first load.
 */

const STOCKIST_SRC = 'https://stockist.co/embed/v1/widget.min.js'

let stockistRequested = false

class StoreLocator extends HTMLElement {
  connectedCallback() {
    // No mount when the widget tag isn't configured — nothing to load.
    if (!this.querySelector('[data-stockist-widget-tag]')) return

    // Frame the map on a location on first load (country/state/city/ZIP).
    // Stockist reads this global when it initialises, so it must be set before
    // the embed script runs. A `?stockist-query=` URL param still overrides it.
    const query = this.dataset.stockistDefaultSearch
    if (query && window.__stockist_pre_selected_query == null) {
      window.__stockist_pre_selected_query = query
    }

    this.#loadStockistOnce()
  }

  #loadStockistOnce() {
    if (stockistRequested || document.querySelector(`script[src="${STOCKIST_SRC}"]`)) {
      stockistRequested = true
      return
    }
    stockistRequested = true

    const script = document.createElement('script')
    script.src = STOCKIST_SRC
    script.async = true
    document.head.appendChild(script)
  }
}

if (!customElements.get('store-locator')) {
  customElements.define('store-locator', StoreLocator)
}
